import { Calendar } from "lucide-react"; // Assuming you use react-feather for icon
import React, { forwardRef, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useFormattedDate from "./useFormattingUtils";

const CustomDateInput = forwardRef(({
  value,
  onChange,
  label,
  required,
  className = "",
  inputStyle = {},
  containerStyle = {},
  wrapperStyle = {},
  placeholder = "Select date",
  showIcon = false,
  iconStyle = {},
  name,
  readOnly = false,
}, ref) => {
  const { formatDate } = useFormattedDate();
  const dateInputRef = useRef(null);
  const [displayValue, setDisplayValue] = useState("");

  const formatDisplayValue = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleDateChange = (e) => {
    const dateString = e.target.value;
    if (dateString) {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        setDisplayValue(`${day}/${month}/${year}`);
      }
    } else {
      setDisplayValue("");
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleDisplayClick = () => {
    if (!readOnly && dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  return (
    <div className={`form-group product-field ${className}`} style={containerStyle}>
      {label && <label>{label}</label>}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px", // space between input and icon
          ...wrapperStyle,
        }}
      >
        <input
          type="text"
          value={displayValue || formatDisplayValue(value)}
          onClick={handleDisplayClick}
          placeholder={placeholder}
          readOnly
          className="form-control-borderless"
          style={{
            cursor: readOnly ? "not-allowed" : "pointer",
            backgroundColor: "#ffffff",
            borderRadius: "0px",
            border:"none",
            width: "240px",
            padding: "0 10px",
            height: inputStyle?.height || "50px",
            ...inputStyle,
          }}
          required={required}
          name={name}
        />

      {showIcon && (
  <Calendar
    onClick={!readOnly ? handleDisplayClick : undefined}
    style={{
      cursor: readOnly ? "default" : "pointer",
      color: "#666",
      fontSize: "20px",
      ...iconStyle,
    }}
    title="Pick a date"
  />
)}


        {/* Hidden native date input */}
        <input
          ref={(node) => {
            dateInputRef.current = node;
            if (ref) {
              ref.current = node;
            }
          }}
          type="date"
          value={value || ""}
          onChange={handleDateChange}
          disabled={readOnly}
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: 0,
            height: 0,
            overflow: "hidden",
          }}
          required={required}
          name={name}
        />
      </div>
    </div>
  );
});

export default CustomDateInput;
